// Utils
import sources from '~/utils/sources';
// Styles
import styles from './video-source.module.scss';

const VideoSource = ({ source }) => {
  const { name, icon } = sources[source];

  return (
    <div className={styles['wrapper']}>
      {icon}
      <span className={styles['wrapper__text']}>{name}</span>
    </div>
  );
};

export default VideoSource;
